import FilterListIcon from '@material-ui/icons/FilterList'
import React from 'react'
import { Button } from 'shared/components/Button/Button'
import { DateRangeValueType } from 'shared/components/DateRangeSelector/DateRangeSelector'
import { Dropdown } from 'shared/components/Dropdown/Dropdown'
import { Text } from 'shared/components/Text/Text'
import { HandlerOf } from 'shared/helpers/typeHelper'
import { lightGray1 } from 'shared/theme/colors'
import styled from 'styled-components'

import { SafetyEventFiltersOption } from './SafetyEventFiltersOption'
import {
  SafetyEventFiltersOptions,
  SafetyEventFiltersTypes,
  SelectedSafetyEventFiltersType,
  SelectedSafetyEventFiltersValuesType,
} from './SafetyEventsFilters.constants'

interface SafetyEventsFilterProps {
  selectedFilters: SelectedSafetyEventFiltersType
  setSelectedFilters: HandlerOf<SelectedSafetyEventFiltersType>
  selectedFiltersValues: SelectedSafetyEventFiltersValuesType
  setSelectedFiltersValues: HandlerOf<SelectedSafetyEventFiltersValuesType>
  selectedDateRangeValue: DateRangeValueType
  setSelectedDateRangeValue: HandlerOf<DateRangeValueType>
  currentlyActiveFilter: SafetyEventFiltersTypes | undefined
  setCurrentlyActiveFilter: HandlerOf<SafetyEventFiltersTypes | undefined>
}

export function SafetyEventsFilter({
  selectedFilters,
  setSelectedFilters,
  selectedFiltersValues,
  setSelectedFiltersValues,
  selectedDateRangeValue,
  setSelectedDateRangeValue,
  currentlyActiveFilter,
  setCurrentlyActiveFilter,
}: SafetyEventsFilterProps) {
  const opener = (
    <StyledIconButton variant="text" icon={<FilterListIcon fontSize="small" />}>
      <Text variant="header3" fontColor={lightGray1}>
        Filter
      </Text>
    </StyledIconButton>
  )

  function selectCurrentlyActiveFilter() {
    if (currentlyActiveFilter) {
      setSelectedFilters({
        ...selectedFilters,
        [currentlyActiveFilter]: !selectedFilters[currentlyActiveFilter],
      })

      setCurrentlyActiveFilter(undefined)
    }
  }

  if (currentlyActiveFilter) {
    return (
      <SafetyEventFiltersOption
        filterType={currentlyActiveFilter}
        label={currentlyActiveFilter}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        selectedFiltersValues={selectedFiltersValues}
        setSelectedFiltersValues={(nextValues) => {
          setSelectedFiltersValues(nextValues)
          selectCurrentlyActiveFilter()
        }}
        selectedDateRangeValue={selectedDateRangeValue}
        setSelectedDateRangeValue={(nextRange, done) => {
          setSelectedDateRangeValue(nextRange)
          if (done) {
            selectCurrentlyActiveFilter()
          }
        }}
        isInitiallyOpen
        opener={opener}
        onBlur={() => setCurrentlyActiveFilter(undefined)}
      />
    )
  }

  return (
    <Dropdown
      noMargin
      onChange={(filter) => setCurrentlyActiveFilter(filter)}
      options={SafetyEventFiltersOptions.filter(({ value }) => !selectedFilters[value])}
      renderOpener={() => opener}
      maxHeight={258}
      width={250}
    />
  )
}

const StyledIconButton = styled(Button)`
  padding: 0 5px;
  border-radius: 0;
  margin-top: -3px;

  svg {
    color: ${lightGray1} !important;
  }
`
